export default __webpack_public_path__ + "static/media/measure3.41094c6c.png";